export const espnteams = [
    {
        "year": 2025,
        "team": "Notre Dame",
        "conference": "FBS Independents",
        "fpi": 21.993,
        "resumeRanks": {
            "strengthOfRecord": 28,
            "fpi": 4,
            "averageWinProbability": 23,
            "strengthOfSchedule": 11,
            "remainingStrengthOfSchedule": 67,
            "gameControl": 9
        },
        "efficiencies": {
            "overall": 87.095,
            "offense": 87.213,
            "defense": 73.484,
            "specialTeams": 58.07
        }
    },
    {
        "year": 2025,
        "team": "Oklahoma State",
        "conference": "Big 12",
        "fpi": -13.542,
        "resumeRanks": {
            "strengthOfRecord": 122,
            "fpi": 117,
            "averageWinProbability": 129,
            "strengthOfSchedule": 36,
            "remainingStrengthOfSchedule": 36,
            "gameControl": 126
        },
        "efficiencies": {
            "overall": 15.08,
            "offense": 18.323,
            "defense": 19.421,
            "specialTeams": 59.277
        }
    },
    {
        "year": 2025,
        "team": "Kansas State",
        "conference": "Big 12",
        "fpi": 7.722,
        "resumeRanks": {
            "strengthOfRecord": 83,
            "fpi": 43,
            "averageWinProbability": 62,
            "strengthOfSchedule": 54,
            "remainingStrengthOfSchedule": 30,
            "gameControl": 53
        },
        "efficiencies": {
            "overall": 58.792,
            "offense": 51.688,
            "defense": 62.94,
            "specialTeams": 45.81
        }
    },
    {
        "year": 2025,
        "team": "Baylor",
        "conference": "Big 12",
        "fpi": 6.115,
        "resumeRanks": {
            "strengthOfRecord": 42,
            "fpi": 46,
            "averageWinProbability": 84,
            "strengthOfSchedule": 65,
            "remainingStrengthOfSchedule": 47,
            "gameControl": 77
        },
        "efficiencies": {
            "overall": 56.97,
            "offense": 71.785,
            "defense": 37.201,
            "specialTeams": 53.436
        }
    },
    {
        "year": 2025,
        "team": "Iowa State",
        "conference": "Big 12",
        "fpi": 9.15,
        "resumeRanks": {
            "strengthOfRecord": 35,
            "fpi": 34,
            "averageWinProbability": 63,
            "strengthOfSchedule": 51,
            "remainingStrengthOfSchedule": 58,
            "gameControl": 50
        },
        "efficiencies": {
            "overall": 66.761,
            "offense": 64.732,
            "defense": 62.4,
            "specialTeams": 50.147
        }
    },
    {
        "year": 2025,
        "team": "Texas Tech",
        "conference": "Big 12",
        "fpi": 18.036,
        "resumeRanks": {
            "strengthOfRecord": 6,
            "fpi": 10,
            "averageWinProbability": 1,
            "strengthOfSchedule": 61,
            "remainingStrengthOfSchedule": 61,
            "gameControl": 1
        },
        "efficiencies": {
            "overall": 93.833,
            "offense": 77.903,
            "defense": 95.795,
            "specialTeams": 61.34
        }
    },
    {
        "year": 2025,
        "team": "Kansas",
        "conference": "Big 12",
        "fpi": 8.483,
        "resumeRanks": {
            "strengthOfRecord": 48,
            "fpi": 39,
            "averageWinProbability": 57,
            "strengthOfSchedule": 24,
            "remainingStrengthOfSchedule": 50,
            "gameControl": 39
        },
        "efficiencies": {
            "overall": 70.558,
            "offense": 73.289,
            "defense": 58.073,
            "specialTeams": 61.358
        }
    },
    {
        "year": 2025,
        "team": "TCU",
        "conference": "Big 12",
        "fpi": 9.792,
        "resumeRanks": {
            "strengthOfRecord": 41,
            "fpi": 31,
            "averageWinProbability": 42,
            "strengthOfSchedule": 60,
            "remainingStrengthOfSchedule": 52,
            "gameControl": 36
        },
        "efficiencies": {
            "overall": 71.728,
            "offense": 67.234,
            "defense": 63.161,
            "specialTeams": 67.339
        }
    },
    {
        "year": 2025,
        "team": "West Virginia",
        "conference": "Big 12",
        "fpi": -2.984,
        "resumeRanks": {
            "strengthOfRecord": 79,
            "fpi": 79,
            "averageWinProbability": 126,
            "strengthOfSchedule": 18,
            "remainingStrengthOfSchedule": 49,
            "gameControl": 97
        },
        "efficiencies": {
            "overall": 36.951,
            "offense": 20.894,
            "defense": 61.395,
            "specialTeams": 46.699
        }
    },
    {
        "year": 2025,
        "team": "South Florida",
        "conference": "American Athletic",
        "fpi": 8.101,
        "resumeRanks": {
            "strengthOfRecord": 14,
            "fpi": 42,
            "averageWinProbability": 50,
            "strengthOfSchedule": 29,
            "remainingStrengthOfSchedule": 79,
            "gameControl": 31
        },
        "efficiencies": {
            "overall": 79.993,
            "offense": 68.365,
            "defense": 75.97,
            "specialTeams": 69.692
        }
    },
    {
        "year": 2025,
        "team": "East Carolina",
        "conference": "American Athletic",
        "fpi": 3.739,
        "resumeRanks": {
            "strengthOfRecord": 81,
            "fpi": 55,
            "averageWinProbability": 68,
            "strengthOfSchedule": 81,
            "remainingStrengthOfSchedule": 87,
            "gameControl": 72
        },
        "efficiencies": {
            "overall": 61.647,
            "offense": 49.61,
            "defense": 68.432,
            "specialTeams": 56.133
        }
    },
    {
        "year": 2025,
        "team": "Tulsa",
        "conference": "American Athletic",
        "fpi": -16.256,
        "resumeRanks": {
            "strengthOfRecord": 117,
            "fpi": 123,
            "averageWinProbability": 98,
            "strengthOfSchedule": 106,
            "remainingStrengthOfSchedule": 95,
            "gameControl": 107
        },
        "efficiencies": {
            "overall": 28.831,
            "offense": 21.465,
            "defense": 46.694,
            "specialTeams": 47.741
        }
    },
    {
        "year": 2025,
        "team": "Temple",
        "conference": "American Athletic",
        "fpi": -7.134,
        "resumeRanks": {
            "strengthOfRecord": 89,
            "fpi": 95,
            "averageWinProbability": 89,
            "strengthOfSchedule": 83,
            "remainingStrengthOfSchedule": 85,
            "gameControl": 90
        },
        "efficiencies": {
            "overall": 44.839,
            "offense": 62.545,
            "defense": 35.858,
            "specialTeams": 30.357
        }
    },
    {
        "year": 2025,
        "team": "Memphis",
        "conference": "American Athletic",
        "fpi": 9.734,
        "resumeRanks": {
            "strengthOfRecord": 17,
            "fpi": 32,
            "averageWinProbability": 20,
            "strengthOfSchedule": 126,
            "remainingStrengthOfSchedule": 77,
            "gameControl": 51
        },
        "efficiencies": {
            "overall": 75.604,
            "offense": 68.84,
            "defense": 69.919,
            "specialTeams": 63.096
        }
    },
    {
        "year": 2025,
        "team": "Navy",
        "conference": "American Athletic",
        "fpi": -2.967,
        "resumeRanks": {
            "strengthOfRecord": 31,
            "fpi": 78,
            "averageWinProbability": 29,
            "strengthOfSchedule": 136,
            "remainingStrengthOfSchedule": 32,
            "gameControl": 85
        },
        "efficiencies": {
            "overall": 52.668,
            "offense": 71.355,
            "defense": 32.367,
            "specialTeams": 55.204
        }
    },
    {
        "year": 2025,
        "team": "Tulane",
        "conference": "American Athletic",
        "fpi": 4.109,
        "resumeRanks": {
            "strengthOfRecord": 20,
            "fpi": 52,
            "averageWinProbability": 33,
            "strengthOfSchedule": 48,
            "remainingStrengthOfSchedule": 78,
            "gameControl": 28
        },
        "efficiencies": {
            "overall": 65.234,
            "offense": 59.309,
            "defense": 64.105,
            "specialTeams": 54.054
        }
    },
    {
        "year": 2025,
        "team": "Western Kentucky",
        "conference": "Conference USA",
        "fpi": -8.343,
        "resumeRanks": {
            "strengthOfRecord": 53,
            "fpi": 98,
            "averageWinProbability": 72,
            "strengthOfSchedule": 132,
            "remainingStrengthOfSchedule": 80,
            "gameControl": 110
        },
        "efficiencies": {
            "overall": 42.208,
            "offense": 45.601,
            "defense": 38.825,
            "specialTeams": 58.605
        }
    },
    {
        "year": 2025,
        "team": "Florida International",
        "conference": "Conference USA",
        "fpi": -16.903,
        "resumeRanks": {
            "strengthOfRecord": 108,
            "fpi": 126,
            "averageWinProbability": 100,
            "strengthOfSchedule": 90,
            "remainingStrengthOfSchedule": 127,
            "gameControl": 103
        },
        "efficiencies": {
            "overall": 24.339,
            "offense": 22.303,
            "defense": 47.013,
            "specialTeams": 16.129
        }
    },
    {
        "year": 2025,
        "team": "Louisiana Tech",
        "conference": "Conference USA",
        "fpi": -6.556,
        "resumeRanks": {
            "strengthOfRecord": 67,
            "fpi": 90,
            "averageWinProbability": 51,
            "strengthOfSchedule": 101,
            "remainingStrengthOfSchedule": 120,
            "gameControl": 65
        },
        "efficiencies": {
            "overall": 56.6,
            "offense": 26.031,
            "defense": 73.669,
            "specialTeams": 76.208
        }
    },
    {
        "year": 2025,
        "team": "Middle Tennessee",
        "conference": "Conference USA",
        "fpi": -18.991,
        "resumeRanks": {
            "strengthOfRecord": 133,
            "fpi": 131,
            "averageWinProbability": 132,
            "strengthOfSchedule": 129,
            "remainingStrengthOfSchedule": 132,
            "gameControl": 135
        },
        "efficiencies": {
            "overall": 15.391,
            "offense": 20.587,
            "defense": 19.696,
            "specialTeams": 51.096
        }
    },
    {
        "year": 2025,
        "team": "UTEP",
        "conference": "Conference USA",
        "fpi": -14.251,
        "resumeRanks": {
            "strengthOfRecord": 132,
            "fpi": 119,
            "averageWinProbability": 128,
            "strengthOfSchedule": 76,
            "remainingStrengthOfSchedule": 126,
            "gameControl": 132
        },
        "efficiencies": {
            "overall": 21.678,
            "offense": 9.488,
            "defense": 54.383,
            "specialTeams": 33.979
        }
    },
    {
        "year": 2025,
        "team": "Oregon State",
        "conference": "Pac-12",
        "fpi": -10.553,
        "resumeRanks": {
            "strengthOfRecord": 134,
            "fpi": 110,
            "averageWinProbability": 131,
            "strengthOfSchedule": 23,
            "remainingStrengthOfSchedule": 134,
            "gameControl": 128
        },
        "efficiencies": {
            "overall": 24.463,
            "offense": 38.621,
            "defense": 31.07,
            "specialTeams": 14.297
        }
    },
    {
        "year": 2025,
        "team": "Washington State",
        "conference": "Pac-12",
        "fpi": -5.871,
        "resumeRanks": {
            "strengthOfRecord": 65,
            "fpi": 88,
            "averageWinProbability": 90,
            "strengthOfSchedule": 38,
            "remainingStrengthOfSchedule": 74,
            "gameControl": 67
        },
        "efficiencies": {
            "overall": 48.892,
            "offense": 37.842,
            "defense": 60.855,
            "specialTeams": 50.679
        }
    },
    {
        "year": 2025,
        "team": "James Madison",
        "conference": "Sun Belt",
        "fpi": 0.169,
        "resumeRanks": {
            "strengthOfRecord": 43,
            "fpi": 65,
            "averageWinProbability": 39,
            "strengthOfSchedule": 119,
            "remainingStrengthOfSchedule": 93,
            "gameControl": 69
        },
        "efficiencies": {
            "overall": 58.642,
            "offense": 41.33,
            "defense": 73.859,
            "specialTeams": 51.924
        }
    },
    {
        "year": 2025,
        "team": "Marshall",
        "conference": "Sun Belt",
        "fpi": -3.625,
        "resumeRanks": {
            "strengthOfRecord": 101,
            "fpi": 80,
            "averageWinProbability": 53,
            "strengthOfSchedule": 71,
            "remainingStrengthOfSchedule": 115,
            "gameControl": 61
        },
        "efficiencies": {
            "overall": 51.787,
            "offense": 48.98,
            "defense": 48.135,
            "specialTeams": 64.706
        }
    },
    {
        "year": 2025,
        "team": "Georgia Southern",
        "conference": "Sun Belt",
        "fpi": -11.467,
        "resumeRanks": {
            "strengthOfRecord": 113,
            "fpi": 112,
            "averageWinProbability": 122,
            "strengthOfSchedule": 58,
            "remainingStrengthOfSchedule": 103,
            "gameControl": 120
        },
        "efficiencies": {
            "overall": 25.133,
            "offense": 41.194,
            "defense": 17.87,
            "specialTeams": 56.733
        }
    },
    {
        "year": 2025,
        "team": "Old Dominion",
        "conference": "Sun Belt",
        "fpi": 3.296,
        "resumeRanks": {
            "strengthOfRecord": 54,
            "fpi": 57,
            "averageWinProbability": 45,
            "strengthOfSchedule": 49,
            "remainingStrengthOfSchedule": 110,
            "gameControl": 45
        },
        "efficiencies": {
            "overall": 71.51,
            "offense": 63.832,
            "defense": 77.415,
            "specialTeams": 20.343
        }
    },
    {
        "year": 2025,
        "team": "Coastal Carolina",
        "conference": "Sun Belt",
        "fpi": -14.231,
        "resumeRanks": {
            "strengthOfRecord": 91,
            "fpi": 118,
            "averageWinProbability": 106,
            "strengthOfSchedule": 99,
            "remainingStrengthOfSchedule": 82,
            "gameControl": 111
        },
        "efficiencies": {
            "overall": 30.005,
            "offense": 13.061,
            "defense": 57.17,
            "specialTeams": 59.925
        }
    },
    {
        "year": 2025,
        "team": "App State",
        "conference": "Sun Belt",
        "fpi": -9.252,
        "resumeRanks": {
            "strengthOfRecord": 78,
            "fpi": 103,
            "averageWinProbability": 64,
            "strengthOfSchedule": 124,
            "remainingStrengthOfSchedule": 92,
            "gameControl": 88
        },
        "efficiencies": {
            "overall": 37.049,
            "offense": 30.812,
            "defense": 49.113,
            "specialTeams": 51.234
        }
    },
    {
        "year": 2025,
        "team": "Georgia State",
        "conference": "Sun Belt",
        "fpi": -17.316,
        "resumeRanks": {
            "strengthOfRecord": 123,
            "fpi": 127,
            "averageWinProbability": 123,
            "strengthOfSchedule": 25,
            "remainingStrengthOfSchedule": 94,
            "gameControl": 102
        },
        "efficiencies": {
            "overall": 16.532,
            "offense": 25.107,
            "defense": 25.932,
            "specialTeams": 21.106
        }
    },
    {
        "year": 2025,
        "team": "South Alabama",
        "conference": "Sun Belt",
        "fpi": -9.346,
        "resumeRanks": {
            "strengthOfRecord": 127,
            "fpi": 104,
            "averageWinProbability": 120,
            "strengthOfSchedule": 82,
            "remainingStrengthOfSchedule": 121,
            "gameControl": 115
        },
        "efficiencies": {
            "overall": 29.077,
            "offense": 40.182,
            "defense": 28.452,
            "specialTeams": 40.495
        }
    },
    {
        "year": 2025,
        "team": "Louisiana",
        "conference": "Sun Belt",
        "fpi": -9.998,
        "resumeRanks": {
            "strengthOfRecord": 120,
            "fpi": 107,
            "averageWinProbability": 116,
            "strengthOfSchedule": 85,
            "remainingStrengthOfSchedule": 112,
            "gameControl": 118
        },
        "efficiencies": {
            "overall": 25.615,
            "offense": 29.159,
            "defense": 34.311,
            "specialTeams": 36.523
        }
    },
    {
        "year": 2025,
        "team": "Texas State",
        "conference": "Sun Belt",
        "fpi": -2.727,
        "resumeRanks": {
            "strengthOfRecord": 104,
            "fpi": 76,
            "averageWinProbability": 46,
            "strengthOfSchedule": 111,
            "remainingStrengthOfSchedule": 104,
            "gameControl": 64
        },
        "efficiencies": {
            "overall": 51.195,
            "offense": 76.727,
            "defense": 28.409,
            "specialTeams": 34.688
        }
    },
    {
        "year": 2025,
        "team": "Arkansas State",
        "conference": "Sun Belt",
        "fpi": -11.672,
        "resumeRanks": {
            "strengthOfRecord": 114,
            "fpi": 113,
            "averageWinProbability": 119,
            "strengthOfSchedule": 100,
            "remainingStrengthOfSchedule": 114,
            "gameControl": 122
        },
        "efficiencies": {
            "overall": 27.673,
            "offense": 30.288,
            "defense": 28.286,
            "specialTeams": 66.831
        }
    },
    {
        "year": 2025,
        "team": "UL Monroe",
        "conference": "Sun Belt",
        "fpi": -16.566,
        "resumeRanks": {
            "strengthOfRecord": 98,
            "fpi": 125,
            "averageWinProbability": 99,
            "strengthOfSchedule": 56,
            "remainingStrengthOfSchedule": 98,
            "gameControl": 106
        },
        "efficiencies": {
            "overall": 27.691,
            "offense": 33.836,
            "defense": 38.669,
            "specialTeams": 20.401
        }
    },
    {
        "year": 2025,
        "team": "Southern Miss",
        "conference": "Sun Belt",
        "fpi": -6.601,
        "resumeRanks": {
            "strengthOfRecord": 73,
            "fpi": 91,
            "averageWinProbability": 47,
            "strengthOfSchedule": 128,
            "remainingStrengthOfSchedule": 109,
            "gameControl": 79
        },
        "efficiencies": {
            "overall": 45.496,
            "offense": 38.45,
            "defense": 54.206,
            "specialTeams": 49.175
        }
    },
    {
        "year": 2025,
        "team": "Troy",
        "conference": "Sun Belt",
        "fpi": -5.002,
        "resumeRanks": {
            "strengthOfRecord": 56,
            "fpi": 83,
            "averageWinProbability": 114,
            "strengthOfSchedule": 88,
            "remainingStrengthOfSchedule": 96,
            "gameControl": 113
        },
        "efficiencies": {
            "overall": 42.533,
            "offense": 36.37,
            "defense": 49.056,
            "specialTeams": 58.48
        }
    },
    {
        "year": 2025,
        "team": "Massachusetts",
        "conference": "Mid-American",
        "fpi": -26.043,
        "resumeRanks": {
            "strengthOfRecord": 134,
            "fpi": 136,
            "averageWinProbability": 133,
            "strengthOfSchedule": 53,
            "remainingStrengthOfSchedule": 123,
            "gameControl": 130
        },
        "efficiencies": {
            "overall": 6.95,
            "offense": 7.329,
            "defense": 14.078,
            "specialTeams": 66.155
        }
    },
    {
        "year": 2025,
        "team": "Delaware",
        "conference": "Conference USA",
        "fpi": -10.328,
        "resumeRanks": {
            "strengthOfRecord": 82,
            "fpi": 109,
            "averageWinProbability": 65,
            "strengthOfSchedule": 120,
            "remainingStrengthOfSchedule": 118,
            "gameControl": 86
        },
        "efficiencies": {
            "overall": 32.797,
            "offense": 48.624,
            "defense": 26.282,
            "specialTeams": 40.68
        }
    },
    {
        "year": 2025,
        "team": "Missouri State",
        "conference": "Conference USA",
        "fpi": -13.282,
        "resumeRanks": {
            "strengthOfRecord": 86,
            "fpi": 116,
            "averageWinProbability": 96,
            "strengthOfSchedule": 52,
            "remainingStrengthOfSchedule": 129,
            "gameControl": 98
        },
        "efficiencies": {
            "overall": 34.974,
            "offense": 35.675,
            "defense": 42.467,
            "specialTeams": 41.799
        }
    },
    {
        "year": 2025,
        "team": "UConn",
        "conference": "FBS Independents",
        "fpi": -2.544,
        "resumeRanks": {
            "strengthOfRecord": 88,
            "fpi": 75,
            "averageWinProbability": 22,
            "strengthOfSchedule": 133,
            "remainingStrengthOfSchedule": 99,
            "gameControl": 62
        },
        "efficiencies": {
            "overall": 54.217,
            "offense": 59.294,
            "defense": 44.263,
            "specialTeams": 60.256
        }
    },
    {
        "year": 2025,
        "team": "BYU",
        "conference": "Big 12",
        "fpi": 14.794,
        "resumeRanks": {
            "strengthOfRecord": 9,
            "fpi": 19,
            "averageWinProbability": 18,
            "strengthOfSchedule": 86,
            "remainingStrengthOfSchedule": 20,
            "gameControl": 22
        },
        "efficiencies": {
            "overall": 86.277,
            "offense": 74.658,
            "defense": 85.408,
            "specialTeams": 55.792
        }
    },
    {
        "year": 2025,
        "team": "Cincinnati",
        "conference": "Big 12",
        "fpi": 8.103,
        "resumeRanks": {
            "strengthOfRecord": 21,
            "fpi": 41,
            "averageWinProbability": 12,
            "strengthOfSchedule": 57,
            "remainingStrengthOfSchedule": 40,
            "gameControl": 15
        },
        "efficiencies": {
            "overall": 80.321,
            "offense": 85.124,
            "defense": 58.161,
            "specialTeams": 73.542
        }
    },
    {
        "year": 2025,
        "team": "Houston",
        "conference": "Big 12",
        "fpi": 2.734,
        "resumeRanks": {
            "strengthOfRecord": 33,
            "fpi": 59,
            "averageWinProbability": 61,
            "strengthOfSchedule": 98,
            "remainingStrengthOfSchedule": 64,
            "gameControl": 73
        },
        "efficiencies": {
            "overall": 63.54,
            "offense": 39.638,
            "defense": 78.244,
            "specialTeams": 59.699
        }
    },
    {
        "year": 2025,
        "team": "UCF",
        "conference": "Big 12",
        "fpi": 3.325,
        "resumeRanks": {
            "strengthOfRecord": 80,
            "fpi": 56,
            "averageWinProbability": 70,
            "strengthOfSchedule": 68,
            "remainingStrengthOfSchedule": 42,
            "gameControl": 71
        },
        "efficiencies": {
            "overall": 47.803,
            "offense": 37.764,
            "defense": 60.773,
            "specialTeams": 49.97
        }
    },
    {
        "year": 2025,
        "team": "UAB",
        "conference": "American Athletic",
        "fpi": -16.545,
        "resumeRanks": {
            "strengthOfRecord": 121,
            "fpi": 124,
            "averageWinProbability": 127,
            "strengthOfSchedule": 87,
            "remainingStrengthOfSchedule": 76,
            "gameControl": 129
        },
        "efficiencies": {
            "overall": 15.283,
            "offense": 42.66,
            "defense": 9.21,
            "specialTeams": 39.971
        }
    },
    {
        "year": 2025,
        "team": "Florida Atlantic",
        "conference": "American Athletic",
        "fpi": -10.139,
        "resumeRanks": {
            "strengthOfRecord": 106,
            "fpi": 108,
            "averageWinProbability": 66,
            "strengthOfSchedule": 116,
            "remainingStrengthOfSchedule": 70,
            "gameControl": 92
        },
        "efficiencies": {
            "overall": 37.531,
            "offense": 45.98,
            "defense": 31.231,
            "specialTeams": 57.709
        }
    },
    {
        "year": 2025,
        "team": "Charlotte",
        "conference": "American Athletic",
        "fpi": -20.082,
        "resumeRanks": {
            "strengthOfRecord": 131,
            "fpi": 133,
            "averageWinProbability": 135,
            "strengthOfSchedule": 117,
            "remainingStrengthOfSchedule": 60,
            "gameControl": 135
        },
        "efficiencies": {
            "overall": 10.124,
            "offense": 10.856,
            "defense": 20.124,
            "specialTeams": 52.092
        }
    },
    {
        "year": 2025,
        "team": "North Texas",
        "conference": "American Athletic",
        "fpi": 0.391,
        "resumeRanks": {
            "strengthOfRecord": 39,
            "fpi": 64,
            "averageWinProbability": 31,
            "strengthOfSchedule": 121,
            "remainingStrengthOfSchedule": 111,
            "gameControl": 58
        },
        "efficiencies": {
            "overall": 62.507,
            "offense": 69.944,
            "defense": 53.566,
            "specialTeams": 35.767
        }
    },
    {
        "year": 2025,
        "team": "Rice",
        "conference": "American Athletic",
        "fpi": -15.771,
        "resumeRanks": {
            "strengthOfRecord": 116,
            "fpi": 122,
            "averageWinProbability": 102,
            "strengthOfSchedule": 123,
            "remainingStrengthOfSchedule": 71,
            "gameControl": 127
        },
        "efficiencies": {
            "overall": 25.348,
            "offense": 23.818,
            "defense": 34.794,
            "specialTeams": 53.593
        }
    },
    {
        "year": 2025,
        "team": "UTSA",
        "conference": "American Athletic",
        "fpi": -0.238,
        "resumeRanks": {
            "strengthOfRecord": 92,
            "fpi": 68,
            "averageWinProbability": 60,
            "strengthOfSchedule": 77,
            "remainingStrengthOfSchedule": 73,
            "gameControl": 59
        },
        "efficiencies": {
            "overall": 51.516,
            "offense": 49.604,
            "defense": 58.473,
            "specialTeams": 35.378
        }
    },
    {
        "year": 2025,
        "team": "Jacksonville State",
        "conference": "Conference USA",
        "fpi": -9.432,
        "resumeRanks": {
            "strengthOfRecord": 109,
            "fpi": 105,
            "averageWinProbability": 93,
            "strengthOfSchedule": 127,
            "remainingStrengthOfSchedule": 133,
            "gameControl": 112
        },
        "efficiencies": {
            "overall": 36.726,
            "offense": 39.005,
            "defense": 41.736,
            "specialTeams": 43.234
        }
    },
    {
        "year": 2025,
        "team": "Liberty",
        "conference": "Conference USA",
        "fpi": -10.735,
        "resumeRanks": {
            "strengthOfRecord": 118,
            "fpi": 111,
            "averageWinProbability": 111,
            "strengthOfSchedule": 115,
            "remainingStrengthOfSchedule": 128,
            "gameControl": 121
        },
        "efficiencies": {
            "overall": 29.795,
            "offense": 27.213,
            "defense": 45.078,
            "specialTeams": 37.418
        }
    },
    {
        "year": 2025,
        "team": "New Mexico State",
        "conference": "Conference USA",
        "fpi": -17.558,
        "resumeRanks": {
            "strengthOfRecord": 103,
            "fpi": 128,
            "averageWinProbability": 73,
            "strengthOfSchedule": 134,
            "remainingStrengthOfSchedule": 75,
            "gameControl": 108
        },
        "efficiencies": {
            "overall": 22.833,
            "offense": 16.674,
            "defense": 35.313,
            "specialTeams": 63.31
        }
    },
    {
        "year": 2025,
        "team": "Sam Houston",
        "conference": "Conference USA",
        "fpi": -19.952,
        "resumeRanks": {
            "strengthOfRecord": 134,
            "fpi": 132,
            "averageWinProbability": 136,
            "strengthOfSchedule": 64,
            "remainingStrengthOfSchedule": 131,
            "gameControl": 134
        },
        "efficiencies": {
            "overall": 15.443,
            "offense": 16.562,
            "defense": 24.914,
            "specialTeams": 45.48
        }
    },
    {
        "year": 2025,
        "team": "Army",
        "conference": "American Athletic",
        "fpi": -5.367,
        "resumeRanks": {
            "strengthOfRecord": 94,
            "fpi": 85,
            "averageWinProbability": 94,
            "strengthOfSchedule": 103,
            "remainingStrengthOfSchedule": 81,
            "gameControl": 95
        },
        "efficiencies": {
            "overall": 44.208,
            "offense": 36.709,
            "defense": 55.068,
            "specialTeams": 53.547
        }
    },
    {
        "year": 2025,
        "team": "Stanford",
        "conference": "ACC",
        "fpi": -5.631,
        "resumeRanks": {
            "strengthOfRecord": 97,
            "fpi": 87,
            "averageWinProbability": 130,
            "strengthOfSchedule": 31,
            "remainingStrengthOfSchedule": 33,
            "gameControl": 109
        },
        "efficiencies": {
            "overall": 34.725,
            "offense": 33.78,
            "defense": 42.408,
            "specialTeams": 46.028
        }
    },
    {
        "year": 2025,
        "team": "California",
        "conference": "ACC",
        "fpi": -3.858,
        "resumeRanks": {
            "strengthOfRecord": 60,
            "fpi": 81,
            "averageWinProbability": 71,
            "strengthOfSchedule": 109,
            "remainingStrengthOfSchedule": 68,
            "gameControl": 80
        },
        "efficiencies": {
            "overall": 42.278,
            "offense": 30.845,
            "defense": 57.266,
            "specialTeams": 55.879
        }
    },
    {
        "year": 2025,
        "team": "Florida State",
        "conference": "ACC",
        "fpi": 11.288,
        "resumeRanks": {
            "strengthOfRecord": 57,
            "fpi": 25,
            "averageWinProbability": 43,
            "strengthOfSchedule": 15,
            "remainingStrengthOfSchedule": 62,
            "gameControl": 32
        },
        "efficiencies": {
            "overall": 75.514,
            "offense": 82.627,
            "defense": 59.713,
            "specialTeams": 36.284
        }
    },
    {
        "year": 2025,
        "team": "Georgia Tech",
        "conference": "ACC",
        "fpi": 9.011,
        "resumeRanks": {
            "strengthOfRecord": 10,
            "fpi": 35,
            "averageWinProbability": 27,
            "strengthOfSchedule": 97,
            "remainingStrengthOfSchedule": 44,
            "gameControl": 34
        },
        "efficiencies": {
            "overall": 72.451,
            "offense": 73.637,
            "defense": 53.798,
            "specialTeams": 75.287
        }
    },
    {
        "year": 2025,
        "team": "Louisville",
        "conference": "ACC",
        "fpi": 8.56,
        "resumeRanks": {
            "strengthOfRecord": 34,
            "fpi": 37,
            "averageWinProbability": 37,
            "strengthOfSchedule": 95,
            "remainingStrengthOfSchedule": 54,
            "gameControl": 49
        },
        "efficiencies": {
            "overall": 73.975,
            "offense": 50.154,
            "defense": 83.502,
            "specialTeams": 65.832
        }
    },
    {
        "year": 2025,
        "team": "Boston College",
        "conference": "ACC",
        "fpi": -6.528,
        "resumeRanks": {
            "strengthOfRecord": 124,
            "fpi": 89,
            "averageWinProbability": 103,
            "strengthOfSchedule": 93,
            "remainingStrengthOfSchedule": 46,
            "gameControl": 101
        },
        "efficiencies": {
            "overall": 32.248,
            "offense": 41.218,
            "defense": 31.485,
            "specialTeams": 45.356
        }
    },
    {
        "year": 2025,
        "team": "Duke",
        "conference": "ACC",
        "fpi": 9.578,
        "resumeRanks": {
            "strengthOfRecord": 45,
            "fpi": 33,
            "averageWinProbability": 76,
            "strengthOfSchedule": 78,
            "remainingStrengthOfSchedule": 65,
            "gameControl": 68
        },
        "efficiencies": {
            "overall": 66.086,
            "offense": 81.649,
            "defense": 43.86,
            "specialTeams": 41.47
        }
    },
    {
        "year": 2025,
        "team": "NC State",
        "conference": "ACC",
        "fpi": 2.973,
        "resumeRanks": {
            "strengthOfRecord": 49,
            "fpi": 58,
            "averageWinProbability": 75,
            "strengthOfSchedule": 28,
            "remainingStrengthOfSchedule": 39,
            "gameControl": 57
        },
        "efficiencies": {
            "overall": 64.154,
            "offense": 74.83,
            "defense": 54.525,
            "specialTeams": 28.522
        }
    },
    {
        "year": 2025,
        "team": "North Carolina",
        "conference": "ACC",
        "fpi": -8.71,
        "resumeRanks": {
            "strengthOfRecord": 100,
            "fpi": 100,
            "averageWinProbability": 101,
            "strengthOfSchedule": 80,
            "remainingStrengthOfSchedule": 69,
            "gameControl": 100
        },
        "efficiencies": {
            "overall": 27.681,
            "offense": 19.139,
            "defense": 39.204,
            "specialTeams": 64.452
        }
    },
    {
        "year": 2025,
        "team": "Wake Forest",
        "conference": "ACC",
        "fpi": -0.428,
        "resumeRanks": {
            "strengthOfRecord": 64,
            "fpi": 69,
            "averageWinProbability": 19,
            "strengthOfSchedule": 112,
            "remainingStrengthOfSchedule": 59,
            "gameControl": 43
        },
        "efficiencies": {
            "overall": 58.759,
            "offense": 35.669,
            "defense": 76.864,
            "specialTeams": 41.599
        }
    },
    {
        "year": 2025,
        "team": "Syracuse",
        "conference": "ACC",
        "fpi": -0.862,
        "resumeRanks": {
            "strengthOfRecord": 51,
            "fpi": 71,
            "averageWinProbability": 105,
            "strengthOfSchedule": 19,
            "remainingStrengthOfSchedule": 27,
            "gameControl": 76
        },
        "efficiencies": {
            "overall": 50.367,
            "offense": 40.655,
            "defense": 56.614,
            "specialTeams": 62.309
        }
    },
    {
        "year": 2025,
        "team": "Pittsburgh",
        "conference": "ACC",
        "fpi": 6.399,
        "resumeRanks": {
            "strengthOfRecord": 58,
            "fpi": 45,
            "averageWinProbability": 16,
            "strengthOfSchedule": 94,
            "remainingStrengthOfSchedule": 34,
            "gameControl": 24
        },
        "efficiencies": {
            "overall": 66.764,
            "offense": 53.803,
            "defense": 68.413,
            "specialTeams": 62.952
        }
    },
    {
        "year": 2025,
        "team": "Clemson",
        "conference": "ACC",
        "fpi": 10.024,
        "resumeRanks": {
            "strengthOfRecord": 69,
            "fpi": 29,
            "averageWinProbability": 74,
            "strengthOfSchedule": 67,
            "remainingStrengthOfSchedule": 56,
            "gameControl": 66
        },
        "efficiencies": {
            "overall": 65.365,
            "offense": 56.326,
            "defense": 69.199,
            "specialTeams": 45.83
        }
    },
    {
        "year": 2025,
        "team": "Virginia",
        "conference": "ACC",
        "fpi": 8.521,
        "resumeRanks": {
            "strengthOfRecord": 29,
            "fpi": 38,
            "averageWinProbability": 14,
            "strengthOfSchedule": 79,
            "remainingStrengthOfSchedule": 72,
            "gameControl": 18
        },
        "efficiencies": {
            "overall": 75.144,
            "offense": 76.911,
            "defense": 59.196,
            "specialTeams": 60.206
        }
    },
    {
        "year": 2025,
        "team": "Virginia Tech",
        "conference": "ACC",
        "fpi": -0.735,
        "resumeRanks": {
            "strengthOfRecord": 105,
            "fpi": 70,
            "averageWinProbability": 104,
            "strengthOfSchedule": 41,
            "remainingStrengthOfSchedule": 35,
            "gameControl": 89
        },
        "efficiencies": {
            "overall": 38.603,
            "offense": 45.813,
            "defense": 36.518,
            "specialTeams": 46.767
        }
    },
    {
        "year": 2025,
        "team": "Miami",
        "conference": "ACC",
        "fpi": 19.711,
        "resumeRanks": {
            "strengthOfRecord": 4,
            "fpi": 8,
            "averageWinProbability": 2,
            "strengthOfSchedule": 14,
            "remainingStrengthOfSchedule": 66,
            "gameControl": 2
        },
        "efficiencies": {
            "overall": 89.576,
            "offense": 79.25,
            "defense": 89.095,
            "specialTeams": 49.3
        }
    },
    {
        "year": 2025,
        "team": "SMU",
        "conference": "ACC",
        "fpi": 8.34,
        "resumeRanks": {
            "strengthOfRecord": 62,
            "fpi": 40,
            "averageWinProbability": 28,
            "strengthOfSchedule": 104,
            "remainingStrengthOfSchedule": 53,
            "gameControl": 42
        },
        "efficiencies": {
            "overall": 69.779,
            "offense": 63.395,
            "defense": 66.358,
            "specialTeams": 57.274
        }
    },
    {
        "year": 2025,
        "team": "Arizona State",
        "conference": "Big 12",
        "fpi": 6.459,
        "resumeRanks": {
            "strengthOfRecord": 32,
            "fpi": 44,
            "averageWinProbability": 86,
            "strengthOfSchedule": 27,
            "remainingStrengthOfSchedule": 55,
            "gameControl": 52
        },
        "efficiencies": {
            "overall": 62.319,
            "offense": 53.206,
            "defense": 74.651,
            "specialTeams": 26.787
        }
    },
    {
        "year": 2025,
        "team": "Arizona",
        "conference": "Big 12",
        "fpi": 5.368,
        "resumeRanks": {
            "strengthOfRecord": 47,
            "fpi": 49,
            "averageWinProbability": 21,
            "strengthOfSchedule": 70,
            "remainingStrengthOfSchedule": 57,
            "gameControl": 33
        },
        "efficiencies": {
            "overall": 65.846,
            "offense": 60.369,
            "defense": 73.513,
            "specialTeams": 24.905
        }
    },
    {
        "year": 2025,
        "team": "Colorado",
        "conference": "Big 12",
        "fpi": 4.093,
        "resumeRanks": {
            "strengthOfRecord": 75,
            "fpi": 53,
            "averageWinProbability": 56,
            "strengthOfSchedule": 45,
            "remainingStrengthOfSchedule": 48,
            "gameControl": 47
        },
        "efficiencies": {
            "overall": 58.051,
            "offense": 66.157,
            "defense": 48.77,
            "specialTeams": 46.875
        }
    },
    {
        "year": 2025,
        "team": "Utah",
        "conference": "Big 12",
        "fpi": 16.31,
        "resumeRanks": {
            "strengthOfRecord": 27,
            "fpi": 14,
            "averageWinProbability": 10,
            "strengthOfSchedule": 72,
            "remainingStrengthOfSchedule": 38,
            "gameControl": 12
        },
        "efficiencies": {
            "overall": 86.295,
            "offense": 79.952,
            "defense": 84.117,
            "specialTeams": 35.634
        }
    },
    {
        "year": 2025,
        "team": "UCLA",
        "conference": "Big Ten",
        "fpi": 0.023,
        "resumeRanks": {
            "strengthOfRecord": 85,
            "fpi": 67,
            "averageWinProbability": 115,
            "strengthOfSchedule": 43,
            "remainingStrengthOfSchedule": 1,
            "gameControl": 87
        },
        "efficiencies": {
            "overall": 48.39,
            "offense": 57.265,
            "defense": 38.115,
            "specialTeams": 56.631
        }
    },
    {
        "year": 2025,
        "team": "USC",
        "conference": "Big Ten",
        "fpi": 19.399,
        "resumeRanks": {
            "strengthOfRecord": 24,
            "fpi": 9,
            "averageWinProbability": 8,
            "strengthOfSchedule": 69,
            "remainingStrengthOfSchedule": 10,
            "gameControl": 11
        },
        "efficiencies": {
            "overall": 85.679,
            "offense": 93.688,
            "defense": 57.21,
            "specialTeams": 40.679
        }
    },
    {
        "year": 2025,
        "team": "Northwestern",
        "conference": "Big Ten",
        "fpi": 2.231,
        "resumeRanks": {
            "strengthOfRecord": 37,
            "fpi": 60,
            "averageWinProbability": 67,
            "strengthOfSchedule": 35,
            "remainingStrengthOfSchedule": 24,
            "gameControl": 56
        },
        "efficiencies": {
            "overall": 55.116,
            "offense": 50.277,
            "defense": 55.776,
            "specialTeams": 58.554
        }
    },
    {
        "year": 2025,
        "team": "Indiana",
        "conference": "Big Ten",
        "fpi": 22.761,
        "resumeRanks": {
            "strengthOfRecord": 1,
            "fpi": 2,
            "averageWinProbability": 5,
            "strengthOfSchedule": 17,
            "remainingStrengthOfSchedule": 51,
            "gameControl": 4
        },
        "efficiencies": {
            "overall": 93.398,
            "offense": 80.19,
            "defense": 93.363,
            "specialTeams": 70.746
        }
    },
    {
        "year": 2025,
        "team": "Maryland",
        "conference": "Big Ten",
        "fpi": 4.418,
        "resumeRanks": {
            "strengthOfRecord": 59,
            "fpi": 51,
            "averageWinProbability": 4,
            "strengthOfSchedule": 102,
            "remainingStrengthOfSchedule": 29,
            "gameControl": 13
        },
        "efficiencies": {
            "overall": 70.763,
            "offense": 47.05,
            "defense": 80.656,
            "specialTeams": 56.779
        }
    },
    {
        "year": 2025,
        "team": "Michigan State",
        "conference": "Big Ten",
        "fpi": -1.669,
        "resumeRanks": {
            "strengthOfRecord": 71,
            "fpi": 73,
            "averageWinProbability": 91,
            "strengthOfSchedule": 34,
            "remainingStrengthOfSchedule": 18,
            "gameControl": 75
        },
        "efficiencies": {
            "overall": 45.134,
            "offense": 46.833,
            "defense": 44.189,
            "specialTeams": 53.35
        }
    },
    {
        "year": 2025,
        "team": "Michigan",
        "conference": "Big Ten",
        "fpi": 15.25,
        "resumeRanks": {
            "strengthOfRecord": 25,
            "fpi": 17,
            "averageWinProbability": 59,
            "strengthOfSchedule": 7,
            "remainingStrengthOfSchedule": 43,
            "gameControl": 23
        },
        "efficiencies": {
            "overall": 76.395,
            "offense": 75.183,
            "defense": 70.888,
            "specialTeams": 43.335
        }
    },
    {
        "year": 2025,
        "team": "Minnesota",
        "conference": "Big Ten",
        "fpi": 0.721,
        "resumeRanks": {
            "strengthOfRecord": 50,
            "fpi": 63,
            "averageWinProbability": 81,
            "strengthOfSchedule": 46,
            "remainingStrengthOfSchedule": 37,
            "gameControl": 81
        },
        "efficiencies": {
            "overall": 51.759,
            "offense": 40.538,
            "defense": 59.424,
            "specialTeams": 58.487
        }
    },
    {
        "year": 2025,
        "team": "Nebraska",
        "conference": "Big Ten",
        "fpi": 11.901,
        "resumeRanks": {
            "strengthOfRecord": 26,
            "fpi": 23,
            "averageWinProbability": 26,
            "strengthOfSchedule": 74,
            "remainingStrengthOfSchedule": 41,
            "gameControl": 35
        },
        "efficiencies": {
            "overall": 70.193,
            "offense": 55.381,
            "defense": 71.592,
            "specialTeams": 70.803
        }
    },
    {
        "year": 2025,
        "team": "Rutgers",
        "conference": "Big Ten",
        "fpi": 4.006,
        "resumeRanks": {
            "strengthOfRecord": 70,
            "fpi": 54,
            "averageWinProbability": 35,
            "strengthOfSchedule": 55,
            "remainingStrengthOfSchedule": 16,
            "gameControl": 38
        },
        "efficiencies": {
            "overall": 53.751,
            "offense": 74.934,
            "defense": 19.795,
            "specialTeams": 67.551
        }
    },
    {
        "year": 2025,
        "team": "Ohio State",
        "conference": "Big Ten",
        "fpi": 25.862,
        "resumeRanks": {
            "strengthOfRecord": 3,
            "fpi": 1,
            "averageWinProbability": 3,
            "strengthOfSchedule": 21,
            "remainingStrengthOfSchedule": 45,
            "gameControl": 3
        },
        "efficiencies": {
            "overall": 93.574,
            "offense": 84.852,
            "defense": 93.316,
            "specialTeams": 34.922
        }
    },
    {
        "year": 2025,
        "team": "Penn State",
        "conference": "Big Ten",
        "fpi": 13.092,
        "resumeRanks": {
            "strengthOfRecord": 99,
            "fpi": 21,
            "averageWinProbability": 36,
            "strengthOfSchedule": 89,
            "remainingStrengthOfSchedule": 8,
            "gameControl": 55
        },
        "efficiencies": {
            "overall": 61.6,
            "offense": 54.987,
            "defense": 55.224,
            "specialTeams": 76.114
        }
    },
    {
        "year": 2025,
        "team": "Washington",
        "conference": "Big Ten",
        "fpi": 13.034,
        "resumeRanks": {
            "strengthOfRecord": 18,
            "fpi": 22,
            "averageWinProbability": 48,
            "strengthOfSchedule": 42,
            "remainingStrengthOfSchedule": 31,
            "gameControl": 41
        },
        "efficiencies": {
            "overall": 77.693,
            "offense": 84.501,
            "defense": 57.376,
            "specialTeams": 51.328
        }
    },
    {
        "year": 2025,
        "team": "Wisconsin",
        "conference": "Big Ten",
        "fpi": 0.11,
        "resumeRanks": {
            "strengthOfRecord": 87,
            "fpi": 66,
            "averageWinProbability": 121,
            "strengthOfSchedule": 9,
            "remainingStrengthOfSchedule": 2,
            "gameControl": 93
        },
        "efficiencies": {
            "overall": 32.357,
            "offense": 19.08,
            "defense": 60.381,
            "specialTeams": 40.448
        }
    },
    {
        "year": 2025,
        "team": "Illinois",
        "conference": "Big Ten",
        "fpi": 10.261,
        "resumeRanks": {
            "strengthOfRecord": 13,
            "fpi": 28,
            "averageWinProbability": 54,
            "strengthOfSchedule": 4,
            "remainingStrengthOfSchedule": 63,
            "gameControl": 21
        },
        "efficiencies": {
            "overall": 78.381,
            "offense": 76.883,
            "defense": 64.343,
            "specialTeams": 69.359
        }
    },
    {
        "year": 2025,
        "team": "Iowa",
        "conference": "Big Ten",
        "fpi": 11.143,
        "resumeRanks": {
            "strengthOfRecord": 36,
            "fpi": 26,
            "averageWinProbability": 44,
            "strengthOfSchedule": 37,
            "remainingStrengthOfSchedule": 17,
            "gameControl": 30
        },
        "efficiencies": {
            "overall": 76.171,
            "offense": 52.408,
            "defense": 82.306,
            "specialTeams": 72.01
        }
    },
    {
        "year": 2025,
        "team": "Oregon",
        "conference": "Big Ten",
        "fpi": 21.942,
        "resumeRanks": {
            "strengthOfRecord": 12,
            "fpi": 5,
            "averageWinProbability": 9,
            "strengthOfSchedule": 26,
            "remainingStrengthOfSchedule": 28,
            "gameControl": 5
        },
        "efficiencies": {
            "overall": 88.037,
            "offense": 83.832,
            "defense": 84.797,
            "specialTeams": 36.327
        }
    },
    {
        "year": 2025,
        "team": "Purdue",
        "conference": "Big Ten",
        "fpi": -2.398,
        "resumeRanks": {
            "strengthOfRecord": 95,
            "fpi": 74,
            "averageWinProbability": 95,
            "strengthOfSchedule": 16,
            "remainingStrengthOfSchedule": 5,
            "gameControl": 74
        },
        "efficiencies": {
            "overall": 43.95,
            "offense": 54.263,
            "defense": 39.326,
            "specialTeams": 36.881
        }
    },
    {
        "year": 2025,
        "team": "Kennesaw State",
        "conference": "Conference USA",
        "fpi": -8.911,
        "resumeRanks": {
            "strengthOfRecord": 63,
            "fpi": 101,
            "averageWinProbability": 40,
            "strengthOfSchedule": 62,
            "remainingStrengthOfSchedule": 130,
            "gameControl": 54
        },
        "efficiencies": {
            "overall": 43.102,
            "offense": 39.291,
            "defense": 47.515,
            "specialTeams": 56.297
        }
    },
    {
        "year": 2025,
        "team": "Bowling Green",
        "conference": "Mid-American",
        "fpi": -6.644,
        "resumeRanks": {
            "strengthOfRecord": 74,
            "fpi": 93,
            "averageWinProbability": 112,
            "strengthOfSchedule": 73,
            "remainingStrengthOfSchedule": 136,
            "gameControl": 104
        },
        "efficiencies": {
            "overall": 34.689,
            "offense": 19.6,
            "defense": 52.391,
            "specialTeams": 67.741
        }
    },
    {
        "year": 2025,
        "team": "Miami (OH)",
        "conference": "Mid-American",
        "fpi": -5.385,
        "resumeRanks": {
            "strengthOfRecord": 102,
            "fpi": 86,
            "averageWinProbability": 85,
            "strengthOfSchedule": 113,
            "remainingStrengthOfSchedule": 107,
            "gameControl": 91
        },
        "efficiencies": {
            "overall": 52.026,
            "offense": 32.191,
            "defense": 59.598,
            "specialTeams": 77.453
        }
    },
    {
        "year": 2025,
        "team": "Ohio",
        "conference": "Mid-American",
        "fpi": -2.921,
        "resumeRanks": {
            "strengthOfRecord": 84,
            "fpi": 77,
            "averageWinProbability": 69,
            "strengthOfSchedule": 44,
            "remainingStrengthOfSchedule": 125,
            "gameControl": 70
        },
        "efficiencies": {
            "overall": 49.82,
            "offense": 52.566,
            "defense": 51.386,
            "specialTeams": 37.231
        }
    },
    {
        "year": 2025,
        "team": "Akron",
        "conference": "Mid-American",
        "fpi": -20.599,
        "resumeRanks": {
            "strengthOfRecord": 125,
            "fpi": 134,
            "averageWinProbability": 110,
            "strengthOfSchedule": 105,
            "remainingStrengthOfSchedule": 135,
            "gameControl": 125
        },
        "efficiencies": {
            "overall": 18.179,
            "offense": 16.319,
            "defense": 35.793,
            "specialTeams": 33.252
        }
    },
    {
        "year": 2025,
        "team": "Ball State",
        "conference": "Mid-American",
        "fpi": -18.102,
        "resumeRanks": {
            "strengthOfRecord": 110,
            "fpi": 129,
            "averageWinProbability": 134,
            "strengthOfSchedule": 84,
            "remainingStrengthOfSchedule": 108,
            "gameControl": 131
        },
        "efficiencies": {
            "overall": 20.388,
            "offense": 31.233,
            "defense": 24.078,
            "specialTeams": 33.766
        }
    },
    {
        "year": 2025,
        "team": "Buffalo",
        "conference": "Mid-American",
        "fpi": -11.966,
        "resumeRanks": {
            "strengthOfRecord": 112,
            "fpi": 114,
            "averageWinProbability": 78,
            "strengthOfSchedule": 130,
            "remainingStrengthOfSchedule": 124,
            "gameControl": 114
        },
        "efficiencies": {
            "overall": 31.26,
            "offense": 24.184,
            "defense": 42.437,
            "specialTeams": 57.368
        }
    },
    {
        "year": 2025,
        "team": "Central Michigan",
        "conference": "Mid-American",
        "fpi": -15.584,
        "resumeRanks": {
            "strengthOfRecord": 96,
            "fpi": 121,
            "averageWinProbability": 97,
            "strengthOfSchedule": 75,
            "remainingStrengthOfSchedule": 119,
            "gameControl": 96
        },
        "efficiencies": {
            "overall": 32.864,
            "offense": 37.16,
            "defense": 30.578,
            "specialTeams": 65.417
        }
    },
    {
        "year": 2025,
        "team": "Eastern Michigan",
        "conference": "Mid-American",
        "fpi": -14.834,
        "resumeRanks": {
            "strengthOfRecord": 128,
            "fpi": 120,
            "averageWinProbability": 124,
            "strengthOfSchedule": 125,
            "remainingStrengthOfSchedule": 113,
            "gameControl": 133
        },
        "efficiencies": {
            "overall": 21.855,
            "offense": 34.007,
            "defense": 16.897,
            "specialTeams": 62.45
        }
    },
    {
        "year": 2025,
        "team": "Kent State",
        "conference": "Mid-American",
        "fpi": -21.189,
        "resumeRanks": {
            "strengthOfRecord": 111,
            "fpi": 135,
            "averageWinProbability": 113,
            "strengthOfSchedule": 13,
            "remainingStrengthOfSchedule": 116,
            "gameControl": 84
        },
        "efficiencies": {
            "overall": 11.856,
            "offense": 18.639,
            "defense": 17.904,
            "specialTeams": 36.763
        }
    },
    {
        "year": 2025,
        "team": "Northern Illinois",
        "conference": "Mid-American",
        "fpi": -11.995,
        "resumeRanks": {
            "strengthOfRecord": 129,
            "fpi": 115,
            "averageWinProbability": 109,
            "strengthOfSchedule": 107,
            "remainingStrengthOfSchedule": 105,
            "gameControl": 116
        },
        "efficiencies": {
            "overall": 24.749,
            "offense": 11.527,
            "defense": 53.349,
            "specialTeams": 45.216
        }
    },
    {
        "year": 2025,
        "team": "Toledo",
        "conference": "Mid-American",
        "fpi": 1.049,
        "resumeRanks": {
            "strengthOfRecord": 107,
            "fpi": 61,
            "averageWinProbability": 17,
            "strengthOfSchedule": 122,
            "remainingStrengthOfSchedule": 122,
            "gameControl": 46
        },
        "efficiencies": {
            "overall": 61.795,
            "offense": 40.988,
            "defense": 77.161,
            "specialTeams": 52.521
        }
    },
    {
        "year": 2025,
        "team": "Western Michigan",
        "conference": "Mid-American",
        "fpi": -6.615,
        "resumeRanks": {
            "strengthOfRecord": 90,
            "fpi": 92,
            "averageWinProbability": 80,
            "strengthOfSchedule": 108,
            "remainingStrengthOfSchedule": 117,
            "gameControl": 99
        },
        "efficiencies": {
            "overall": 45.796,
            "offense": 31.42,
            "defense": 69.315,
            "specialTeams": 31.47
        }
    },
    {
        "year": 2025,
        "team": "San Diego State",
        "conference": "Mountain West",
        "fpi": -1.043,
        "resumeRanks": {
            "strengthOfRecord": 55,
            "fpi": 72,
            "averageWinProbability": 24,
            "strengthOfSchedule": 135,
            "remainingStrengthOfSchedule": 91,
            "gameControl": 60
        },
        "efficiencies": {
            "overall": 69.595,
            "offense": 43.567,
            "defense": 78.518,
            "specialTeams": 71.754
        }
    },
    {
        "year": 2025,
        "team": "San Jos\u00e9 State",
        "conference": "Mountain West",
        "fpi": -8.216,
        "resumeRanks": {
            "strengthOfRecord": 119,
            "fpi": 97,
            "averageWinProbability": 83,
            "strengthOfSchedule": 66,
            "remainingStrengthOfSchedule": 106,
            "gameControl": 83
        },
        "efficiencies": {
            "overall": 37.335,
            "offense": 50.479,
            "defense": 32.02,
            "specialTeams": 43.24
        }
    },
    {
        "year": 2025,
        "team": "Colorado State",
        "conference": "Mountain West",
        "fpi": -6.733,
        "resumeRanks": {
            "strengthOfRecord": 115,
            "fpi": 94,
            "averageWinProbability": 118,
            "strengthOfSchedule": 92,
            "remainingStrengthOfSchedule": 86,
            "gameControl": 119
        },
        "efficiencies": {
            "overall": 29.372,
            "offense": 34.735,
            "defense": 35.766,
            "specialTeams": 35.636
        }
    },
    {
        "year": 2025,
        "team": "Hawai'i",
        "conference": "Mountain West",
        "fpi": -8.623,
        "resumeRanks": {
            "strengthOfRecord": 68,
            "fpi": 99,
            "averageWinProbability": 52,
            "strengthOfSchedule": 118,
            "remainingStrengthOfSchedule": 88,
            "gameControl": 82
        },
        "efficiencies": {
            "overall": 38.29,
            "offense": 25.512,
            "defense": 54.576,
            "specialTeams": 65.616
        }
    },
    {
        "year": 2025,
        "team": "Boise State",
        "conference": "Mountain West",
        "fpi": 5.789,
        "resumeRanks": {
            "strengthOfRecord": 44,
            "fpi": 48,
            "averageWinProbability": 49,
            "strengthOfSchedule": 39,
            "remainingStrengthOfSchedule": 97,
            "gameControl": 40
        },
        "efficiencies": {
            "overall": 63.865,
            "offense": 63.201,
            "defense": 63.804,
            "specialTeams": 32.327
        }
    },
    {
        "year": 2025,
        "team": "New Mexico",
        "conference": "Mountain West",
        "fpi": -4.363,
        "resumeRanks": {
            "strengthOfRecord": 72,
            "fpi": 82,
            "averageWinProbability": 107,
            "strengthOfSchedule": 50,
            "remainingStrengthOfSchedule": 100,
            "gameControl": 94
        },
        "efficiencies": {
            "overall": 45.789,
            "offense": 52.335,
            "defense": 41.914,
            "specialTeams": 48.577
        }
    },
    {
        "year": 2025,
        "team": "Fresno State",
        "conference": "Mountain West",
        "fpi": -7.339,
        "resumeRanks": {
            "strengthOfRecord": 66,
            "fpi": 96,
            "averageWinProbability": 87,
            "strengthOfSchedule": 114,
            "remainingStrengthOfSchedule": 83,
            "gameControl": 105
        },
        "efficiencies": {
            "overall": 41.543,
            "offense": 32.099,
            "defense": 50.45,
            "specialTeams": 61.96
        }
    },
    {
        "year": 2025,
        "team": "Utah State",
        "conference": "Mountain West",
        "fpi": -5.12,
        "resumeRanks": {
            "strengthOfRecord": 76,
            "fpi": 84,
            "averageWinProbability": 79,
            "strengthOfSchedule": 30,
            "remainingStrengthOfSchedule": 89,
            "gameControl": 63
        },
        "efficiencies": {
            "overall": 46.135,
            "offense": 59.193,
            "defense": 36.513,
            "specialTeams": 46.792
        }
    },
    {
        "year": 2025,
        "team": "Air Force",
        "conference": "Mountain West",
        "fpi": -9.024,
        "resumeRanks": {
            "strengthOfRecord": 130,
            "fpi": 102,
            "averageWinProbability": 108,
            "strengthOfSchedule": 110,
            "remainingStrengthOfSchedule": 102,
            "gameControl": 117
        },
        "efficiencies": {
            "overall": 35.211,
            "offense": 78.316,
            "defense": 8.362,
            "specialTeams": 39.741
        }
    },
    {
        "year": 2025,
        "team": "UNLV",
        "conference": "Mountain West",
        "fpi": 0.866,
        "resumeRanks": {
            "strengthOfRecord": 22,
            "fpi": 62,
            "averageWinProbability": 38,
            "strengthOfSchedule": 131,
            "remainingStrengthOfSchedule": 84,
            "gameControl": 78
        },
        "efficiencies": {
            "overall": 53.049,
            "offense": 61.358,
            "defense": 41.708,
            "specialTeams": 60.045
        }
    },
    {
        "year": 2025,
        "team": "Nevada",
        "conference": "Mountain West",
        "fpi": -18.285,
        "resumeRanks": {
            "strengthOfRecord": 126,
            "fpi": 130,
            "averageWinProbability": 125,
            "strengthOfSchedule": 91,
            "remainingStrengthOfSchedule": 90,
            "gameControl": 124
        },
        "efficiencies": {
            "overall": 18.547,
            "offense": 10.691,
            "defense": 39.969,
            "specialTeams": 51.363
        }
    },
    {
        "year": 2025,
        "team": "Wyoming",
        "conference": "Mountain West",
        "fpi": -9.93,
        "resumeRanks": {
            "strengthOfRecord": 93,
            "fpi": 106,
            "averageWinProbability": 117,
            "strengthOfSchedule": 96,
            "remainingStrengthOfSchedule": 101,
            "gameControl": 123
        },
        "efficiencies": {
            "overall": 31.475,
            "offense": 21.747,
            "defense": 54.22,
            "specialTeams": 36.078
        }
    },
    {
        "year": 2025,
        "team": "Auburn",
        "conference": "SEC",
        "fpi": 11.874,
        "resumeRanks": {
            "strengthOfRecord": 40,
            "fpi": 24,
            "averageWinProbability": 58,
            "strengthOfSchedule": 5,
            "remainingStrengthOfSchedule": 25,
            "gameControl": 20
        },
        "efficiencies": {
            "overall": 76.652,
            "offense": 61.865,
            "defense": 81.899,
            "specialTeams": 44.043
        }
    },
    {
        "year": 2025,
        "team": "Arkansas",
        "conference": "SEC",
        "fpi": 8.717,
        "resumeRanks": {
            "strengthOfRecord": 77,
            "fpi": 36,
            "averageWinProbability": 82,
            "strengthOfSchedule": 3,
            "remainingStrengthOfSchedule": 7,
            "gameControl": 37
        },
        "efficiencies": {
            "overall": 66.599,
            "offense": 85.585,
            "defense": 35.84,
            "specialTeams": 49.236
        }
    },
    {
        "year": 2025,
        "team": "Florida",
        "conference": "SEC",
        "fpi": 10.83,
        "resumeRanks": {
            "strengthOfRecord": 52,
            "fpi": 27,
            "averageWinProbability": 88,
            "strengthOfSchedule": 1,
            "remainingStrengthOfSchedule": 14,
            "gameControl": 26
        },
        "efficiencies": {
            "overall": 68.507,
            "offense": 47.626,
            "defense": 80.501,
            "specialTeams": 52.412
        }
    },
    {
        "year": 2025,
        "team": "Georgia",
        "conference": "SEC",
        "fpi": 21.459,
        "resumeRanks": {
            "strengthOfRecord": 8,
            "fpi": 6,
            "averageWinProbability": 41,
            "strengthOfSchedule": 8,
            "remainingStrengthOfSchedule": 26,
            "gameControl": 16
        },
        "efficiencies": {
            "overall": 83.931,
            "offense": 79.069,
            "defense": 74.382,
            "specialTeams": 64.2
        }
    },
    {
        "year": 2025,
        "team": "Kentucky",
        "conference": "SEC",
        "fpi": 4.645,
        "resumeRanks": {
            "strengthOfRecord": 61,
            "fpi": 50,
            "averageWinProbability": 92,
            "strengthOfSchedule": 6,
            "remainingStrengthOfSchedule": 19,
            "gameControl": 48
        },
        "efficiencies": {
            "overall": 55.781,
            "offense": 39.102,
            "defense": 65.235,
            "specialTeams": 63.402
        }
    },
    {
        "year": 2025,
        "team": "LSU",
        "conference": "SEC",
        "fpi": 15.207,
        "resumeRanks": {
            "strengthOfRecord": 11,
            "fpi": 18,
            "averageWinProbability": 32,
            "strengthOfSchedule": 22,
            "remainingStrengthOfSchedule": 6,
            "gameControl": 19
        },
        "efficiencies": {
            "overall": 79.885,
            "offense": 61.498,
            "defense": 83.581,
            "specialTeams": 56.426
        }
    },
    {
        "year": 2025,
        "team": "Missouri",
        "conference": "SEC",
        "fpi": 15.518,
        "resumeRanks": {
            "strengthOfRecord": 23,
            "fpi": 15,
            "averageWinProbability": 15,
            "strengthOfSchedule": 59,
            "remainingStrengthOfSchedule": 13,
            "gameControl": 29
        },
        "efficiencies": {
            "overall": 74.501,
            "offense": 74.525,
            "defense": 66.735,
            "specialTeams": 44.056
        }
    },
    {
        "year": 2025,
        "team": "Ole Miss",
        "conference": "SEC",
        "fpi": 16.883,
        "resumeRanks": {
            "strengthOfRecord": 7,
            "fpi": 12,
            "averageWinProbability": 13,
            "strengthOfSchedule": 63,
            "remainingStrengthOfSchedule": 23,
            "gameControl": 17
        },
        "efficiencies": {
            "overall": 72.791,
            "offense": 75.062,
            "defense": 56.906,
            "specialTeams": 61.603
        }
    },
    {
        "year": 2025,
        "team": "Oklahoma",
        "conference": "SEC",
        "fpi": 14.385,
        "resumeRanks": {
            "strengthOfRecord": 15,
            "fpi": 20,
            "averageWinProbability": 6,
            "strengthOfSchedule": 32,
            "remainingStrengthOfSchedule": 3,
            "gameControl": 8
        },
        "efficiencies": {
            "overall": 79.67,
            "offense": 61.037,
            "defense": 82.927,
            "specialTeams": 67.976
        }
    },
    {
        "year": 2025,
        "team": "Vanderbilt",
        "conference": "SEC",
        "fpi": 15.293,
        "resumeRanks": {
            "strengthOfRecord": 16,
            "fpi": 16,
            "averageWinProbability": 25,
            "strengthOfSchedule": 33,
            "remainingStrengthOfSchedule": 9,
            "gameControl": 14
        },
        "efficiencies": {
            "overall": 89.208,
            "offense": 93.804,
            "defense": 65.146,
            "specialTeams": 57.586
        }
    },
    {
        "year": 2025,
        "team": "Texas A&M",
        "conference": "SEC",
        "fpi": 17.781,
        "resumeRanks": {
            "strengthOfRecord": 2,
            "fpi": 11,
            "averageWinProbability": 11,
            "strengthOfSchedule": 20,
            "remainingStrengthOfSchedule": 11,
            "gameControl": 7
        },
        "efficiencies": {
            "overall": 81.853,
            "offense": 73.486,
            "defense": 82.835,
            "specialTeams": 43.15
        }
    },
    {
        "year": 2025,
        "team": "Texas",
        "conference": "SEC",
        "fpi": 20.931,
        "resumeRanks": {
            "strengthOfRecord": 30,
            "fpi": 7,
            "averageWinProbability": 55,
            "strengthOfSchedule": 10,
            "remainingStrengthOfSchedule": 15,
            "gameControl": 27
        },
        "efficiencies": {
            "overall": 80.921,
            "offense": 59.534,
            "defense": 86.892,
            "specialTeams": 59.809
        }
    },
    {
        "year": 2025,
        "team": "Alabama",
        "conference": "SEC",
        "fpi": 22.428,
        "resumeRanks": {
            "strengthOfRecord": 5,
            "fpi": 3,
            "averageWinProbability": 34,
            "strengthOfSchedule": 2,
            "remainingStrengthOfSchedule": 22,
            "gameControl": 6
        },
        "efficiencies": {
            "overall": 85.665,
            "offense": 81.707,
            "defense": 78.397,
            "specialTeams": 48.686
        }
    },
    {
        "year": 2025,
        "team": "Mississippi State",
        "conference": "SEC",
        "fpi": 5.981,
        "resumeRanks": {
            "strengthOfRecord": 38,
            "fpi": 47,
            "averageWinProbability": 30,
            "strengthOfSchedule": 40,
            "remainingStrengthOfSchedule": 4,
            "gameControl": 25
        },
        "efficiencies": {
            "overall": 68.547,
            "offense": 52.925,
            "defense": 68.603,
            "specialTeams": 75.27
        }
    },
    {
        "year": 2025,
        "team": "South Carolina",
        "conference": "SEC",
        "fpi": 9.93,
        "resumeRanks": {
            "strengthOfRecord": 46,
            "fpi": 30,
            "averageWinProbability": 77,
            "strengthOfSchedule": 12,
            "remainingStrengthOfSchedule": 12,
            "gameControl": 44
        },
        "efficiencies": {
            "overall": 66.352,
            "offense": 41.786,
            "defense": 74.329,
            "specialTeams": 71.471
        }
    },
    {
        "year": 2025,
        "team": "Tennessee",
        "conference": "SEC",
        "fpi": 16.739,
        "resumeRanks": {
            "strengthOfRecord": 19,
            "fpi": 13,
            "averageWinProbability": 7,
            "strengthOfSchedule": 47,
            "remainingStrengthOfSchedule": 21,
            "gameControl": 10
        },
        "efficiencies": {
            "overall": 80.04,
            "offense": 79.792,
            "defense": 72.202,
            "specialTeams": 44.658
        }
    }
]